import { FC } from 'react';
import { FlattenOptionData } from 'rc-select/lib/interface';
import { BaseOptionType } from 'rc-select/lib/Select';
import { Option } from '@utils/generateOptions';
import { highlightMatches } from '@utils/highlightMatches';
import { Tooltip } from 'antd';

export type CustomOptionType = FlattenOptionData<BaseOptionType> & {
  disabled?: boolean;
};
export type OptionRendererProps = {
  option: CustomOptionType;
  searchValue: string;
  selectedOptions: Option[];
  select?: string;
  selected?: string;
};

export const OptionRenderer: FC<OptionRendererProps> = ({
  option,
  searchValue,
  selectedOptions,
  select = 'Add',
  selected = 'Added',
}) => {
  return (
    <div className='flex items-center justify-between'>
      <Tooltip
        color='white'
        title={
          option.data.label.length > 15 ? (
            <span className='text-1424 text-black'>{option.label}</span>
          ) : undefined
        }
      >
        <span
          className={`text-1624 font-medium leading-6 ${
            option.data.label.length > 15 && 'max-w-[20rem] truncate'
          }`}
        >
          {highlightMatches(option.data.label, searchValue)}
        </span>
      </Tooltip>
      {!selectedOptions.find(item => item.value === option.value) ? (
        <span className='text-vividTangelo'>{select}</span>
      ) : (
        <span className='text-pastelBlue'>{selected}</span>
      )}
    </div>
  );
};
